import {
  BoatCoverage,
  CaravanCoverage,
  TravelCoverage,
} from 'Types/coverages/coverages.types';

export const SuperTravelCoverages = [
  TravelCoverage.SUPER_75_DAYS,
  TravelCoverage.SUPER_90_DAYS,
  TravelCoverage.SUPER_120_DAYS,
  TravelCoverage.SUPER_COVERAGE_FOR_INSURED_ONLY,
  TravelCoverage.SUPER_COVERAGE_FOR_INSURED_ONLY_90_DAYS,
  TravelCoverage.SUPER_COVERAGE_FOR_INSURED_ONLY_120_DAYS,
];

export const StandardTravelCoverages = [
  TravelCoverage.STANDARD,
  TravelCoverage.COVERAGE_FOR_INSURED_ONLY,
];

export const KaskoCaravanCoverages = [
  CaravanCoverage.FULL_OWN_DAMAGE,
  CaravanCoverage.FULL_OWN_DAMAGE_EXTENDED_MOVABLES_1,
  CaravanCoverage.FULL_OWN_DAMAGE_EXTENDED_MOVABLES_2,
  CaravanCoverage.FULL_OWN_DAMAGE_EXTENDED_MOVABLES_3,
  CaravanCoverage.FULL_OWN_DAMAGE_EXTENDED_PERMANENT_PLACE,
  CaravanCoverage.FULL_OWN_DAMAGE_EXTENDED_PERMANENT_PLACE_MOVABLES_1,
  CaravanCoverage.FULL_OWN_DAMAGE_EXTENDED_PERMANENT_PLACE_MOVABLES_2,
  CaravanCoverage.FULL_OWN_DAMAGE_EXTENDED_PERMANENT_PLACE_MOVABLES_3,
];

export const ExtendedBoatCoverages = [
  BoatCoverage.INBOARD_MOTOR_FULL_OWN_DAMAGE_EXTENDED,
  BoatCoverage.OUTBOARD_MOTOR_FULL_OWN_DAMAGE_EXTENDED,
  BoatCoverage.SAILING_BOAT_FULL_OWN_DAMAGE_EXTENDED,
  BoatCoverage.MOTOR_FULL_OWN_DAMAGE_EXTENDED,
];

export const KaskoBoatCoverages = [
  BoatCoverage.ROWBOAT_CANOE_KAYAK_FULL_OWN_DAMAGE,
  BoatCoverage.INBOARD_MOTOR_FULL_OWN_DAMAGE_EXTENDED,
  BoatCoverage.INBOARD_MOTOR_FULL_OWN_DAMAGE,
  BoatCoverage.OUTBOARD_MOTOR_FULL_OWN_DAMAGE_EXTENDED,
  BoatCoverage.OUTBOARD_MOTOR_FULL_OWN_DAMAGE,
  BoatCoverage.SAILING_BOAT_FULL_OWN_DAMAGE,
  BoatCoverage.SAILING_BOAT_FULL_OWN_DAMAGE_EXTENDED,
  BoatCoverage.MOTOR_FULL_OWN_DAMAGE_EXTENDED,
  BoatCoverage.MOTOR_FULL_OWN_DAMAGE,
  BoatCoverage.JETSKI_FULL_OWN_DAMAGE,
];

export const DelkaskoBoatCoverages = [
  BoatCoverage.ROWBOAT_CANOE_KAYAK_REDUCED_OWN_DAMAGE,
  BoatCoverage.INBOARD_MOTOR_REDUCED_OWN_DAMAGE,
  BoatCoverage.OUTBOARD_MOTOR_REDUCED_OWN_DAMAGE,
  BoatCoverage.SAILING_BOAT_REDUCED_OWN_DAMAGE,
  BoatCoverage.MOTOR_REDUCED_OWN_DAMAGE,
  BoatCoverage.JETSKI_REDUCED_OWN_DAMAGE,
];

export enum DanskeBankCoverageKeys {
  TOTAL = 'auroraTotal',
  BASIS = 'auroraBasis',
  WORK = 'auroraWorkDisability',
}
